import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Tam-ekran ölümcül hata — reload loop tespit edildiğinde gösterilir.
 * Kullanıcıya sade Türkçe mesaj + (varsa) kısa cihaz kimliği gösterir; teknik sebep
 * yalnız konsola/loga yazılır, ekrana SIZMAZ (O8). Otomatik kurtarma reload-guard'dan.
 */
@customElement('fp-fatal-error')
export class FpFatalError extends LitElement {
    @property({ type: String }) reasons = '';

    connectedCallback(): void {
        super.connectedCallback();
        // Teknik sebep kullanıcıya değil, loga.
        if (this.reasons) console.error('[fatal] sebep:', this.reasons);
    }

    /** Destek ekibinin cihazı bulması için kısa kimlik (JWT device_id ilk 8). */
    private shortDeviceId(): string {
        try {
            const token = localStorage.getItem('fp.device.token');
            const payload = token?.split('.')[1];
            if (!payload) return '';
            const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
            const id = (json.device_id as string) ?? (json.sub as string) ?? '';
            return id ? id.slice(0, 8) : '';
        } catch {
            return '';
        }
    }

    static styles = css`
        :host {
            position: fixed;
            inset: 0;
            background: #000;
            color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-family: 'Inter', system-ui, sans-serif;
            z-index: 99999;
        }
        h1 {
            font-size: 2.2rem;
            color: #dc2626;
            margin: 1rem 2rem 0.5rem;
            text-align: center;
        }
        p {
            font-size: 1.4rem;
            opacity: 0.85;
            margin: 0.5rem 2rem;
            text-align: center;
            max-width: 40ch;
        }
        .support {
            font-size: 1.75rem;
            margin-top: 2rem;
            color: #f59e0b;
        }
        .small {
            font-size: 0.8rem;
            opacity: 0.4;
            margin-top: 3rem;
            max-width: 80vw;
            text-align: center;
            word-break: break-word;
        }
    `;

    render() {
        const dev = this.shortDeviceId();
        return html`
            <svg viewBox="0 0 24 24" width="3.5rem" height="3.5rem" fill="none" stroke="#dc2626"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <h1>Ekran geçici olarak hizmet veremiyor</h1>
            <p>Bağlantı birkaç dakika içinde kendiliğinden yeniden denenecek.</p>
            <p class="support">Sorun sürerse destek ekibiyle iletişime geçin</p>
            ${dev ? html`<p class="small">Ekran kimliği: ${dev}</p>` : ''}
        `;
    }
}
